export default __webpack_public_path__ + "static/media/betslip-footer.2c6a45f0.png";